import { Theme } from 'theme-ui';

const colors: Theme['colors'] = {
  text: '#1B202E',
  background: '#F6F6F9',
  primary: '#0073e9',
  secondary: '#1B202E',
  accent: '#2B40B5',
  highlight: '#E4E6EC',
  muted: '#9AA0B5',
  gray0: '#9AA0B5',
  gray1: '#E4E6EC',
  gray2: '#EEEFF3',
  gray3: '#F6F6F9',
  error: '#E03B54',
  success: '#00CD98',
};

export default colors;
